module.exports = __webpack_public_path__ + "img/SVG8_MemberType.2f13142b.svg";